import dashboard from './menu/dashboard'
import administrator from './menu/administrator'
import rolePermission from './menu/rolePermission'
import company from './menu/company'
import senior from './menu/senior'
import master from './menu/master'
import agent from './menu/agent'
import player from './menu/player'
import assistant from './menu/assistant'
import liveBetting from './menu/liveBetting'
import baccaratLive from './menu/baccaratLive'
import parley from './menu/parley'
import requestDeposit from './menu/requestDeposit'
import requestWithdraw from './menu/requestWithdraw'
import baccaratResult from './menu/baccaratResult'
import slotBalanceReport from './menu/slotBalanceReport'
import assistantVip from './menu/assistantVip'
import report from './menu/report'
import configuration from './menu/configuration'

export default [
  ...dashboard,
  ...administrator,
  ...rolePermission,
  ...liveBetting,
  // ...baccaratResult,
  // ...baccaratLive,
  // ...parley,
  ...company,
  ...senior,
  ...master,
  ...agent,
  ...player,
  ...assistant,
  // ...assistantVip,
  ...report,
  ...requestDeposit,
  ...requestWithdraw,
  ...configuration,
]
